export enum RegistrationResponseType {
    NotSet = 0,
    Success = "Success",
    DuplicateUser = "Duplicate User",
    Unknown = "Unknown Error"
}
